// extracted by mini-css-extract-plugin
export var errorIcon = "_ox-1";
export var nameLogo = "_ox-0";